import type { WorkBlock } from '../../utils/work';

type Group = { kind: 'h' | 'p'; text: string } | { kind: 'ul'; items: string[] };

/** Texte riche issu de l'API: paragraphes, intertitres et listes à puces (lignes courtes sous un intertitre). */
export default function RichText({ blocks, firstHeadingLarge = false, className = '' }: { blocks: WorkBlock[]; firstHeadingLarge?: boolean; className?: string }) {
  const groups = blocks.reduce<Group[]>((acc, b) => {
    if (b.kind !== 'li') { acc.push({ kind: b.kind, text: b.text }); return acc; }
    const last = acc[acc.length - 1];
    if (last && last.kind === 'ul') last.items.push(b.text); else acc.push({ kind: 'ul', items: [b.text] });
    return acc;
  }, []);

  return (
    <div className={`space-y-5 text-[1.0625rem] leading-relaxed ${className}`}>
      {groups.map((g, n) => {
        if (g.kind === 'h') return <h3 key={n} className={`font-display font-bold normal-case leading-tight tracking-normal text-black ${n === 0 && firstHeadingLarge ? 'text-[1.75rem] md:text-[2.25rem]' : 'pt-4 text-[1.375rem]'}`}>{g.text}</h3>;
        if (g.kind === 'ul') return (
          <ul key={n} className="space-y-2.5">
            {g.items.map((it) => <li key={it} className="flex gap-3"><span aria-hidden className="mt-[0.7rem] h-1.5 w-1.5 shrink-0 bg-brand" />{it}</li>)}
          </ul>
        );
        return <p key={n}>{g.text}</p>;
      })}
    </div>
  );
}
